<template>
  <div class="dashboard-plus-wrapper">
    <el-card>
      <div class="dashboard-plus-button">
        <i class="el-icon-plus"></i>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
.dashboard-plus-wrapper {
  height: 100%;
  .el-card {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 222px;
    width: 100%;
    height: 100%;
    .el-card__body {
      display: flex;
      justify-content: center;
      align-items: center;
      .dashboard-plus-button {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        width: 180px;
        height: 180px;        
        cursor: pointer;
        &:hover {
          border-color: #409EFF;
        }
        .el-icon-plus {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// DashboardPlusButton.vue?581a0ba5